import React from 'react';
import { ReduxFormInput as Input } from '@ott/input-next-deprecated';

export default class AdaptedInput extends React.PureComponent {
  handleChange = (e) => {
    const {
      input: { onChange },
      onChange: onFieldChange,
    } = this.props;

    if (onChange) {
      onChange(e);
    }

    if (onFieldChange) {
      onFieldChange(e);
    }
  };

  render() {
    const { input, meta, 'data-mask': dataMask, ...rest } = this.props;

    const value = dataMask || input.value;

    return <Input input={input} meta={meta} {...rest} value={value} onChange={this.handleChange} />;
  }
}
